import React from "react";
import { motion } from "framer-motion";

const cities = [
    "Vancouver", "Burnaby", "Richmond", "Surrey", "Coquitlam",
    "Port Moody", "New Westminster", "North Vancouver", "Delta", "Langley",
];

export default function Coverage() {
    return (
        <section data-testid="coverage-strip" className="border-t border-b border-line bg-bg">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                <div className="flex items-center gap-3 shrink-0">
                    <span className="w-1.5 h-1.5 rounded-full bg-gold" />
                    <span className="eyebrow">Coverage · Lower Mainland, BC</span>
                </div>
                <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-ink/75">
                    {cities.map((c, i) => (
                        <motion.span
                            key={c}
                            initial={{ opacity: 0, y: 6 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.35, delay: i * 0.03 }}
                            className="font-mono text-[12px] tracking-wide"
                        >
                            {c}
                        </motion.span>
                    ))}
                </div>
            </div>
        </section>
    );
}
